import ComponentElement from 'components/component-element';
import {createElement} from 'methods/utils';

function Place($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$text = this.$element.querySelector('.js-placeText');
    this.$dots = createElement(
        `<span> ...</span>`
    );

    this.originalText = this.$text.textContent;
    this.fitText();
}

Place.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Place, 'constructor', {
    value: Place,
    writable: true,
    enumerable: false,
});

Place.prototype.isFitNeeded = function() {
    return this.$text.textContent.length && this.$text.scrollHeight > this.$text.offsetHeight
}

Place.prototype.fitText = function() {
    this.$text.textContent = this.originalText;

    if (!this.isFitNeeded()) {
        return;
    }

    while (this.isFitNeeded()) {
        if (this.$dots.offsetParent) {
            this.$text.removeChild(this.$dots);
        }
        const words = this.$text.textContent.split(' ');
        this.$text.textContent = words.slice(0, -1).join(' ');

        if (/[^.?!]$/.test(this.$text.textContent)) {
            this.$text.appendChild(this.$dots);
        }
    }
}

export default Place;
